<template>
  <b-row>

    <!-- Billing date -->
    <b-col md="6">
      <field-date
          :name="'billingDate'"
          :model.sync="outgoingInvoice.billingDate"
      />
    </b-col>

    <!-- Payment term -->
    <b-col md="6">
      <field-select
          :model.sync="outgoingInvoice.paymentTerm"
          :name="'paymentTerms'"
          :options="autocompletePaymentTerms"
          :label="'term'"
          :isRequired="true"
          :clearable="false"
      />
    </b-col>

    <!-- Payment method -->
    <b-col :md="(isEmployeePaymentMethod || isBankAccountRequired)?4:6">
      <field-select
          :model.sync="outgoingInvoice.paymentMethod"
          :name="'paymentMethod'"
          :options="autocompletePaymentMethods"
          :label="'name'"
          :isRequired="true"
          :clearable="false"
      />
    </b-col>

    <!-- Bank account -->
    <b-col
        v-if="isBankAccountRequired"
        md="4"
    >
      <field-select
          :name="capitalize($t('accountInvolved'))"
          :model.sync="outgoingInvoice.bankAccount"
          :options="autocompleteBankAccounts"
          :is-required="true"
      />
    </b-col>

    <!-- Col: Discount -->
    <b-col :md="(isEmployeePaymentMethod || isBankAccountRequired)?4:6">
      <field-discount
          :name="'discount'"
          :discount.sync="outgoingInvoice.discount"
          :isDiscountPercent.sync="outgoingInvoice.isDiscountPercent"
          @input="$emit('changePreTaxAmount', 'discount', $event)"
      />
    </b-col>

  </b-row>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { isObject } from '../../../../utils/utils'
import { capitalize} from '../../../../utils/filter'

import useAPI from '@/utils/useAPI'
import FieldInput from '@/components/input/Input'
import FieldSelect from '../../../input/Select2.vue'
import FieldDate from '@/components/input/Date'
import FieldDiscount from '@/components/input/Discount'
import FieldEmployee from '@/components/input/Employee'

export default {
  components: {
    FieldInput,
    FieldSelect,
    FieldDate,
    FieldDiscount,
    FieldEmployee
  },
  props: {
    outgoingInvoice: {
      type: Object,
      default: () => {}
    }
  },
  setup (props) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const {
      autocompleteBankAccounts,
      autocompletePaymentMethods,
      autocompletePaymentTerms,
      paymentTerms
    } = useAPI()

    const isEmployeePaymentMethod = computed(() => {
      return isObject(props.outgoingInvoice.paymentMethod) ? props.outgoingInvoice.paymentMethod.id == 5 : props.outgoingInvoice.paymentMethod == 5
    })

    const isBankAccountRequired = computed(() => {
      return !isEmployeePaymentMethod.value && (isObject(props.outgoingInvoice.paymentMethod) ? props.outgoingInvoice.paymentMethod.id != 7 : props.outgoingInvoice.paymentMethod != 7)
    })

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components
      isObject,
      capitalize,

      // Data

      // Computed
      autocompleteBankAccounts,
      autocompletePaymentMethods,
      autocompletePaymentTerms,
      paymentTerms,
      isEmployeePaymentMethod,
      isBankAccountRequired,

      // Methods
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>